import localStorageService from './localStorageService';

export const getChatState = (configId: string): 'open' | 'closed' => {
  try {
    const storageItem = localStorageService.get(configId);

    if (storageItem) {
      const chatState = JSON.parse(storageItem)?.state;
      return chatState !== 'open' && chatState !== 'closed'
        ? 'open'
        : chatState;
    }

    return 'open';
  } catch (_error) {
    return 'open';
  }
};

export const setChatState = (
  configId: string,
  chatState: 'open' | 'closed',
) => {
  try {
    const storageItem = localStorageService.get(configId);
    if (storageItem) {
      const parsedData = JSON.parse(storageItem);
      parsedData.state = chatState;
      localStorageService.set(configId, parsedData);
    } else {
      localStorageService.set(configId, { state: chatState });
    }
  } catch (error) {
    console.error('Error setting chat state', error);
  }
};
